import { gql } from '@apollo/client';

export const DELETE_VENDOR_REPRESENTATIVE = gql`
  mutation DeleteVendorRepresentative($vendorId: String!, $vendorRepresentativeId: String!) {
    deleteVendorRepresentative(vendorId: $vendorId, vendorRepresentativeId: $vendorRepresentativeId) {
      email
      firstName
      id
      lastName
      roles
    }
  }
`;
